import React from "react";
// import {
//   IoMusicalNotesOutline,
//   IoDesktopOutline,
//   IoKeyOutline,
//   IoCopyOutline,
//   IoShareSocialOutline,
//   IoPencilOutline,
//   IoCloudUploadOutline,
//   IoVideocamOutline,
//   IoDocumentTextOutline
// } from "react-icons/io5";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import "./SongbookIntro.scss";

// const FEATURES = [
//   { icon: IoMusicalNotesOutline, text: "Переглядати пісні та приховувати акорди" },
//   { icon: IoKeyOutline, text: "Змінювати тональність в один клік" },
//   { icon: IoDesktopOutline, text: "Відкривати пісні у режимі повного екрану" },
//   { icon: IoCopyOutline, text: "Копіювати пісні до власного пісенника" },
//   { icon: IoShareSocialOutline, text: "Ділитися посиланнями на пісні" }
// ];

// const COLLAB_FEATURES = [
//   { icon: IoPencilOutline, text: "Додавати та редагувати пісні" },
//   { icon: IoCloudUploadOutline, text: "Завантажувати медіафайли для пісень" },
//   { icon: IoVideocamOutline, text: "Створювати презентації для служіння" },
//   { icon: IoDocumentTextOutline, text: "Завантажувати пісенник у форматі DOCX" }
// ];

const SongbookIntro = ({
  collabPermission,
  toggleSidebar,
  noSongs
}: {
  collabPermission: boolean;
  toggleSidebar?: (sidebar: "left" | "right", e: any) => void;
  noSongs?: boolean;
}) => {
  return (
    <div className="sb-intro">
      <svg className="sb-intro-defs">
        <defs>
          <linearGradient
            id="sbArrowGradient"
            x1="0%"
            y1="0%"
            x2="100%"
            y2="100%"
          >
            <stop offset="0%" stopColor="#4facfe" />
            <stop offset="100%" stopColor="#f093fb" />
          </linearGradient>
        </defs>
      </svg>

      <div className="sb-intro-arrows">
        <div
          className="sb-intro-arrow sb-intro-arrow--left"
          onClick={(e) => toggleSidebar?.("left", e)}
        >
          <FaArrowLeft className="sb-intro-arrow-icon" />
          <span className="sb-intro-arrow-label">Перелік пісень</span>
          <span className="sb-intro-arrow-label">Категорії</span>
          <span className="sb-intro-arrow-label">Сортування</span>
        </div>
        <div
          className="sb-intro-arrow sb-intro-arrow--right"
          onClick={(e) => toggleSidebar?.("right", e)}
        >
          <FaArrowRight className="sb-intro-arrow-icon" />
          <span className="sb-intro-arrow-label">Медіа ресурси</span>
          {collabPermission && (
            <span className="sb-intro-arrow-label">Додати пісню</span>
          )}
          <span className="sb-intro-arrow-label">Презентація</span>
        </div>
      </div>

      {noSongs && (
        <div className="sb-intro-no-songs">
          <span className="sb-intro-arrow-label">Тут пісень ще немає</span>
        </div>
      )}

      {/* <div className="sb-intro-section">
        <h3 className="sb-intro-section-title">Що можна робити у пісеннику</h3>
        <ul className="sb-intro-list">
          {FEATURES.map(({ icon: Icon, text }, i) => (
            <li key={i} className="sb-intro-list-item">
              <Icon className="sb-intro-list-icon" />
              <span>{text}</span>
            </li>
          ))}
        </ul>
      </div>

      {collabPermission && (
        <div className="sb-intro-section">
          <h3 className="sb-intro-section-title sb-intro-section-title--collab">
            Додатково як редактор
          </h3>
          <ul className="sb-intro-list">
            {COLLAB_FEATURES.map(({ icon: Icon, text }, i) => (
              <li key={i} className="sb-intro-list-item sb-intro-list-item--collab">
                <Icon className="sb-intro-list-icon" />
                <span>{text}</span>
              </li>
            ))}
          </ul>
        </div>
      )} */}
    </div>
  );
};

export default SongbookIntro;
